import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '../atoms/SelectField';
var StockFilter = function (_a) {
    var columnDef = _a.columnDef, onFilterChanged = _a.onFilterChanged, label = _a.label;
    var t = useTranslation().t;
    var handleChange = React.useCallback(function (event) {
        var value = event.target.value;
        onFilterChanged(columnDef.tableData.id, value);
    }, [columnDef, onFilterChanged]);
    return (React.createElement(Select, { fullWidth: true, margin: "none", variant: "standard", value: columnDef.tableData.filterValue || null, onChange: handleChange, label: label || '', items: [
            { text: t('labels.all'), value: '' },
            { text: t('labels.inStock'), value: 'inStock' },
        ] }));
};
export default StockFilter;
